export const SETUP_ANALYTICS = 'SETUP_ANALYTICS';
export const SETUP_SENTRY = 'SETUP_SENTRY';
export const SET_TRACKING_DATA = 'SET_TRACKING_DATA';
export const FETCH_DASHBOARD_CONTENT = 'FETCH_DASHBOARD_CONTENT';
